import { useReviewTransform } from 'hooks/reviews/useReviewTransform';
import { ReviewStarEmpty, ReviewStarFull, ReviewStarHalfFull } from 'public/svg/IconsSvg';
import { twJoin } from 'tailwind-merge';
import { REVIEW_RATING_DEFAULT_MAX, REVIEW_RATING_DEFAULT_MIN } from 'types/review';

type StarRatingType = 'small' | 'normal' | 'big';

export type StarRating = {
    rating: number;
    min?: number;
    max?: number;
    type?: StarRatingType;
    className?: string;
};

export const StarRating = ({
    rating,
    min = REVIEW_RATING_DEFAULT_MIN,
    max = REVIEW_RATING_DEFAULT_MAX,
    type = 'small',
    className,
}: StarRating) => {
    const { ratingToStars } = useReviewTransform();
    const stars = ratingToStars(rating, max, min, false);

    const starClass = twJoin(
        type === 'small' && 'w-3.5 h-3.5',
        type === 'normal' && 'w-4.5 h-4.5',
        type === 'big' && 'w-7 h-7',
    );

    return (
        <div className={twJoin('flex items-center', className)}>
            {stars.map((star, index) => {
                if (star === 'empty') {
                    return <ReviewStarEmpty key={index} className={starClass} />;
                } else if (star === 'half') {
                    return <ReviewStarHalfFull key={index} className={starClass} />;
                }

                return <ReviewStarFull key={index} className={starClass} />;
            })}
        </div>
    );
};
